<template>
    <div>
            <a-radio-group v-model="searchP.extype" @change="handleSubmit">
                <a-radio-button value="export">
                    导出配置
                </a-radio-button>
                <a-radio-button value="import">
                    导入配置
                </a-radio-button>
            </a-radio-group>
            <br />
            <br />
            <platformTab @platformcodeChange="handlePlatformChange"></platformTab>
    </div>
</template>

<script>
import platformTab from "../com/platformtab.vue"

let searchP={
    extype:'export',
    platformcode:'',
};



export default {
    data() {
        return {
            form: this.$form.createForm(this),
            searchP:searchP,
        };
    },
    methods: {

        handlePlatformChange(v){
            this.searchP.platformcode = v;
            this.searchP.keyword = '';
            this.handleSubmit();
        },

        //筛选提交
        handleSubmit() {
            console.log(this.searchP)
            this.$emit("onSearchChange",this.searchP)
        },
        //筛选重置
        handleSearchReset() {
            this.searchP ={
                extype:'export',
                platformcode:'',
            };
            this.handleSubmit()
        },
    },

    components: {
        platformTab
    },

    mounted() {
        const {query} = this.$route;    
        if(query.extype){
            this.searchP={
                extype:query.extype || '',
                platformcode:query.platformcode || '',
            };
        }
    },
    destroyed(){
    },
};

</script>

<style lang="less" scoped>
.editable-row-operations a {
  margin-right: 8px;
}
td{
  padding: 10px 10px;
}
</style>
